import { useState } from 'react';
import { Divider, Chip, Tooltip } from '@mui/material';
import { MdRefresh } from "react-icons/md";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import CustomModal from '../../../common/CustomModal';
import SuggestedPrograms from './SuggestedPrograms';

import { getAge } from '../../../utils/date';

function PatientInfo({ patient, getSuggestedPrograms }) {
    const [openResetSPModal, setOpenResetSPModal] = useState(false);
    const [openPatientInfoModal, setOpenPatientInfoModal] = useState(false);

    const sp = getSuggestedPrograms(patient?.suggested_programs);
    return (
        <>
            <div className="brg-pp brg-pp-patients-info">
                {/* <h5>
                    PATIENT INFO
                </h5> */}

                <div id='brg-pp-pi-content'>
                    {/* <Divider textAlign="left"><Chip label="Personal info" size="small" /></Divider> */}
                    <div className="brg-pp-pi-group">
                        <div>
                            <h6>NAME:</h6>
                            <h6>{(patient?.first_name + " " + patient?.last_name).toUpperCase()}</h6>
                        </div>
                        <div>
                            <h6>EMAIL:</h6>
                            <h6>{patient?.email || "-NO EMAIL-"}</h6>
                        </div>
                        <div>
                            <h6>AGE:</h6>
                            <h6>{getAge(patient?.dob)}</h6>
                        </div>
                        <div>
                            <h6>GENDER:</h6>
                            <h6>{{ m: "MALE", f: "FEMALE" }?.[patient?.gender] || ""}</h6>
                        </div>
                        <div>
                            <h6>PATIENT ID:</h6>
                            <h6>{patient?.patient_id}</h6>
                        </div>
                        <div>
                            <h6>CASE ID:</h6>
                            <h6>{patient?.case_id}</h6>
                        </div>
                        <div>
                            <h6>APPOINTMENT ID:</h6>
                            <h6>{patient?.appointment_id}</h6>
                        </div>
                    </div>

                    {/* <Divider textAlign="left"><Chip label="Suggested Programs" size="small" /></Divider> */}
                    <div className="brg-pp-pi-group suggested-programs">
                        <div className="row">
                            <div className="col-md-12">
                                <Chip label={`${sp[0]?.title?.toUpperCase()} ${sp[0]?.level ? (" - " + sp[0]?.level) : ""} (${sp[0]?.type?.toUpperCase()})`} variant="outlined" />
                            </div>
                            <div className="col-md-12">
                                <Chip label={`${sp[1]?.title?.toUpperCase()} ${sp[1]?.level ? (" - " + sp[1]?.level) : ""} (${sp[1]?.type?.toUpperCase()})`} variant="outlined" />
                            </div>
                            <div className="col-md-12">
                                <Chip label={`${sp[2]?.title?.toUpperCase()} ${sp[2]?.level ? (" - " + sp[2]?.level) : ""} (${sp[2]?.type?.toUpperCase()})`} variant="outlined" />
                            </div>

                        </div>
                        <MdRefresh onClick={() => {
                            setOpenResetSPModal(true);
                        }} />

                    </div>

                    <div className='brg-pp-pi-group pi-toggle'>
                        <h5 onClick={() => {
                            setOpenPatientInfoModal(true);
                        }}>Patient Information <ArrowForwardIosIcon /></h5>
                    </div>

                    {/* <Divider textAlign="left"><Chip label="Therapy History" size="small" /></Divider> */}
                    {/* <div className="brg-pp-pi-group">
                        <div className="pi-multiple-values">
                            <h6>GOALS:</h6>
                            <h6><em>1.</em> &nbsp; {patient?.goal_1}</h6>
                            <h6><em>2.</em> &nbsp; {patient?.goal_2}</h6>
                            <h6><em>3.</em> &nbsp; {patient?.goal_3}</h6>
                        </div>

                        <div className="pi-multiple-values">
                            <h6>DIAGNOSIS:</h6>
                            <h6>&nbsp; {patient?.diagnosis}</h6>
                        </div>

                        <div className="pi-multiple-values">
                            <h6>PRIMARY LIMITATIONS:</h6>
                            <h6>&nbsp; {patient?.primary_limitation}</h6>
                        </div>

                        <div className="pi-multiple-values">
                            <h6>SECONDARY LIMITATIONS:</h6>
                            <h6>&nbsp; {patient?.secondary_limitation}</h6>
                        </div>

                        <div className="pi-multiple-values">
                            <h6>SUBJECTIVE SUMMARY:</h6>
                            <h6>&nbsp; {patient?.subjective_summary}</h6>
                        </div>

                        <div className="pi-multiple-values">
                            <h6>OBJECTIVE SUMMARY:</h6>
                            <h6>&nbsp; {patient?.objective_summary}</h6>
                        </div>

                        <div className="pi-multiple-values">
                            <h6>ASSESSMENT SUMMARY:</h6>
                            <h6>&nbsp; {patient?.assessment_summary}</h6>
                        </div>

                        <div className="pi-multiple-values">
                            <h6>PLAN SUMMARY:</h6>
                            <h6>&nbsp; {patient?.plan_summary}</h6>
                        </div>
                    </div> */}
                </div>
            </div>


            <CustomModal
                size="m"
                toggle={setOpenResetSPModal}
                show={openResetSPModal}
                title="Reset Suggested Programs"
                body={(
                    <>
                        <SuggestedPrograms patient={patient} programs={sp} getSuggestedPrograms={getSuggestedPrograms} />
                    </>
                )}
            />

            <CustomModal
                size="m"
                toggle={setOpenPatientInfoModal}
                show={openPatientInfoModal}
                title="Patient Information"
                body={(
                    <div id="brg-pp-additional-info">
                        <div className="brg-pp-pi-group">
                            <div className="pi-multiple-values">
                                <h6>GOALS:</h6>
                                <h6><em>1.</em> &nbsp; {patient?.goal_1}</h6>
                                <h6><em>2.</em> &nbsp; {patient?.goal_2}</h6>
                                <h6><em>3.</em> &nbsp; {patient?.goal_3}</h6>
                            </div>

                            <div className="pi-multiple-values">
                                <h6>DIAGNOSIS:</h6>
                                <h6>&nbsp; {patient?.diagnosis || "-"}</h6>
                            </div>

                            <div className="pi-multiple-values">
                                <h6>PRIMARY LIMITATIONS:</h6>
                                <h6>&nbsp; {patient?.primary_limitation || "-"}</h6>
                            </div>

                            <div className="pi-multiple-values">
                                <h6>SECONDARY LIMITATIONS:</h6>
                                <h6>&nbsp; {patient?.secondary_limitation || "-"}</h6>
                            </div>

                            <div className="pi-multiple-values">
                                <h6>SUBJECTIVE SUMMARY:</h6>
                                <h6>&nbsp; {patient?.subjective_summary || "-"}</h6>
                            </div>

                            <div className="pi-multiple-values">
                                <h6>OBJECTIVE SUMMARY:</h6>
                                <h6>&nbsp; {patient?.objective_summary || "-"}</h6>
                            </div>

                            <div className="pi-multiple-values">
                                <h6>ASSESSMENT SUMMARY:</h6>
                                <h6>&nbsp; {patient?.assessment_summary || "-"}</h6>
                            </div>

                            <div className="pi-multiple-values">
                                <h6>PLAN SUMMARY:</h6>
                                <h6>&nbsp; {patient?.plan_summary || "-"}</h6>
                            </div>
                        </div>
                    </div>
                )}
            />
        </>
    );
}

export default PatientInfo;